<cab-doc-page [page]="StaticContentPage.PrivacyPolicy" />
